import AnalyticsAdapter from '../../analytics/AnalyticsAdapter';
import { loadMetaPixel, trackMetaPageView } from '../../helpers/metaPixel';

// THE CONSENT DEFAULT IS SET FROM THE SAVED COOKIE IN index.html BEFORE ANY TAG
// LOADS, SO ONLY THE BANNER'S ANSWER NEEDS TO UPDATE IT HERE. REJECTING ONLY
// TURNS ANALYTICS OFF: SESSION, LANGUAGE AND PROMO TOKEN STORAGE ARE ESSENTIAL
const useAnalyticsConsent = () => {
  const handleAccept = () => {
    AnalyticsAdapter.setConsent(true);
    loadMetaPixel();
    // THE CURRENT PAGE WAS SHOWN BEFORE THE PIXEL EXISTED
    trackMetaPageView();
  };

  const handleDecline = () => {
    AnalyticsAdapter.setConsent(false);
  };

  return { handleAccept, handleDecline };
};

export default useAnalyticsConsent;
